// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./admin/backoffice.scss
// module id = 5
// module chunks = 0